import {
  CustomDateInput,
  CustomEditor,
  CustomInput,
  Dropzone,
} from "@/components";
import { convertToEditorState } from "@/lib/utils";
import { ILesson } from "@/types/lesson.types";
import { sub } from "date-fns";
import { useFormikContext } from "formik";

type Props = {
  lesson?: ILesson;
};

const SimilarFields = ({ lesson }: Props) => {
  const { values, handleChange, setFieldValue } = useFormikContext();

  return (
    <>
      {!lesson && (
        <CustomInput
          label="Assignment Title"
          value={(values as any).topic}
          onChange={handleChange}
          placeholder="Enter assignment topic"
          name="topic"
        />
      )}
      <CustomEditor
        label="Assignment Question(s)"
        setState={(editorState) => setFieldValue("content", editorState)}
        defaultEditorState={convertToEditorState((values as any).content ?? "")}
      />
      <Dropzone name="attachments" type="file" />
      <CustomDateInput
        label="Due Date"
        placeholder="Enter due date"
        selected={(values as any).due_date}
        onSelect={(date) => setFieldValue("due_date", date)}
        timeFormat="dd MMM yyyy"
        name="due_date"
        mode="single"
        disabled={(date) => date < sub(new Date(), { days: 1 })}
      // showDatePicker
      />
    </>
  );
};

export default SimilarFields;
